import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import {
    fetchAllBloodRelationshipsFailure,
    fetchAllBloodRelationshipsSuccess,
    setBloodRelationshipsWholeList
} from '@actions/ssap/ssapActionCreators';

export function* allBloodRelationshipsSaga() {
    try {
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const allBloodRelationShips = yield call([ssapService, ssapService.getBloodAllRelationships]);
        if(allBloodRelationShips) {
            yield put(setBloodRelationshipsWholeList(allBloodRelationShips));
            yield put(fetchAllBloodRelationshipsSuccess());
        } else {
            yield put(fetchAllBloodRelationshipsFailure());
        }
    } catch(e) {
        yield put(fetchAllBloodRelationshipsFailure());
    }
}